import { createTheme, DEFAULT_THEME } from '@mantine/core';

export const theme = createTheme({
    /** Put your mantine theme override here */
    fontFamily: `Twemoji Country Flags, ${DEFAULT_THEME.fontFamily}`,
});
